import Account from '@/helper/AccountHelper.js';
import ConfigManager from '@/config/ConfigManager.js'
import BzbsApi from '@/core/Http/BzbsApi.js';
import { map } from 'rxjs/operators';

export default {
    apiGetFriendLink: function () {
        let token = Account.getToken();
        let url = ConfigManager.getApiUrl() + '/referral/link';
        return BzbsApi.connectBzbsPost(url, token, null).pipe(map((res) => {
            return res.data.link;
        }));
    },

    apiGetFriendHistory: function (params) {
        let token = Account.getToken();
        
        let url = ConfigManager.getApiUrl() + '/referral';
        return BzbsApi.connectBzbsGet(url, token, params).pipe(map((res) => {
            return res.data;
        }));
    },

    apiGetFriendHistorySummary: function (params) {
        let token = Account.getToken();
        
        let url = ConfigManager.getApiUrl() + '/referral/summary';
        return BzbsApi.connectBzbsGet(url, token, params).pipe(map((res) => {
            return res.data;
        }));
    },
}
